import DemoControls from './header/demo-controls.component'
import ControlsDropdown from './header/controls-dropdown.component'
import PatientInfo from './header/patient-info.component'
import PatientConsent from './header/patient-consent.component'
import MedicalAlertList from 'src/components/medical-alert-list/medical-alert-list.component'
import { useCurrentPatientFile } from './patient-file.provider'

const PatientFileHeader = () => {
  const { patient } = useCurrentPatientFile()
  return (
    <div className="c-relative c-flex c-flex-col [&>*:not(:first-child)]:c-mt-2">
      <section className="lg:c-absolute c-ml-auto c-right-0 c-top-0 c-flex c-gap-2 c-py-2">
        <DemoControls patient={patient} />
        {!patient.isArchived && <ControlsDropdown patient={patient} />}
      </section>
      <PatientInfo patient={patient} />
      <PatientConsent patient={patient} />
      <MedicalAlertList medicalAlertList={patient.PatientMedAlerts} showPinnedOnly />
    </div>
  )
}

export default PatientFileHeader
